<p class="analytics-legend">
  ➚ - shows the change in value from the previous day<br>
  💯 - displays the total value for the period of a particular day
</p>

<style>
  .analytics-legend {
    line-height: 2;
  }
</style>
